<template>
    <v-card class="pa-5" v-if="activeUser">
        <h3>User information</h3>
        <v-divider class="my-3" />
        <v-text-field :value="activeUser.id" disabled label="Id"></v-text-field>
        <v-text-field disabled label="Email" :value="activeUser.email"></v-text-field>
        <v-text-field v-model="activeUser.name" label="Name" :value="activeUser.name"></v-text-field>
        <v-select
            v-model="activeUser.status"
            :items="statusOptions"
            label="Status"
            :value="activeUser.status"
            item-text="label"
            item-value="value"
        ></v-select>
        <v-select
            v-model="activeUser.role"
            :items="user.role === 'country_manager' ? countryManagerRoleOptions : roleOptions"
            label="Role"
            :value="activeUser.role"
            item-text="label"
            item-value="value"
            @change="emptyTagsField($event)"
        ></v-select>
        <v-select
            item-value="code"
            item-text="name"
            :items="countries"
            :disabled="user.role !== 'super_admin' && activeUser.role !== 'country_manager'"
            multiple
            label="Managed countries"
            v-model="activeUser.managed_countries"
        >
        </v-select>
        <v-select
            item-value="label"
            item-text="label"
            :disabled="user.role !== 'super_admin'"
            multiple
            :items="tags"
            label="Tags"
            v-model="tagPermissions"
        >
        </v-select>
        <v-checkbox
            :ripple="false"
            :value="false"
            label="Send recommendation email"
            dense
            hide-details
            v-model="activeUser.send_recommendation_email"
        />
        <v-checkbox
            :ripple="false"
            :value="false"
            label="Send summary email"
            dense
            hide-details
            v-model="activeUser.send_annual_summary_email"
        />
        <v-btn @click="handleSaveClick" class="mt-5" color="success">Save</v-btn>
    </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
    name: 'UserViewForm',
    data() {
        return {
            statusOptions: [
                { label: 'Active', value: 'active' },
                { label: 'Inactive', value: 'inactive' },
                { label: 'Blocked', value: 'blocked' },
                { label: 'Deleted', value: 'deleted' },
            ],
            roleOptions: [
                { label: 'Demo', value: 'demo' },
                { label: 'Admin', value: 'admin' },
                { label: 'Customer', value: 'customer' },
                { label: 'Country manager', value: 'country_manager' },
            ],
            countryManagerRoleOptions: [
                { label: 'Demo', value: 'demo' },
                { label: 'Customer', value: 'customer' },
            ],
            tagPermissions: [],
        }
    },
    computed: {
        ...mapState('user', ['activeUser', 'userPermissions']),
        ...mapState('userPermissions', ['tags', 'userTags']),
        ...mapState('auth', ['user']),
        ...mapState('country', ['countries']),
    },
    async mounted() {
        if (this.user.role === 'super_admin' || this.user.role === 'admin' || this.user.role === 'country_manager') {
            this.roleOptions.push({ label: 'Super Admin', value: 'super_admin' })
            await this.fetchAllTags()
        }
        await this.fetchCountries()
    },
    watch: {
        userTags() {
            this.tagPermissions = this.userTags
        },
    },
    methods: {
        ...mapActions('user', ['updateUser']),
        ...mapActions('userPermissions', ['fetchAllTags']),
        ...mapMutations('user', ['setUserPermissions']),
        ...mapActions('country', ['fetchCountries']),
        async handleSaveClick() {
            let tagObjects = []
            if (this.tagPermissions.length > 0) {
                for (let tp of this.tagPermissions) {
                    this.tags.forEach((tag, index) => {
                        if (tag.label === tp) {
                            tagObjects.push(this.tags[index])
                        }
                    })
                }
            }
            for (let key in this.tags[0].value) {
                this.tags[0].value[key].map(action => {
                    if (this.userPermissions[key].includes(action)) {
                        let index = this.userPermissions[key].indexOf(action)
                        if (index !== -1) {
                            this.userPermissions[key].splice(index, 1)
                        }
                    }
                })
            }
            if (this.tagPermissions.length > 0) {
                let i = 0
                while (i <= this.tagPermissions.length) {
                    for (let key in tagObjects[i]?.value) {
                        let checkTagPermissions = tagObjects[i]?.value[key].every(p =>
                            this.userPermissions[key].includes(p)
                        )
                        if (!checkTagPermissions) {
                            tagObjects[i]?.value[key].map(action => {
                                if (!this.userPermissions[key].includes(action)) {
                                    this.userPermissions[key].push(action)
                                }
                            })
                        }
                    }

                    i++
                }
            }
            await this.updateUser()
            await this.setUserPermissions(this.userPermissions)
        },

        emptyTagsField(event) {
            this.tagPermissions = []
            if (event === 'super_admin') {
                let superAdminTag = this.tags.find(tag => tag?.label === 'Superadmin')
                this.tagPermissions.push(superAdminTag?.label)
            } else if (event === 'admin' || event === 'customer' || event === 'country_manager') {
                let adminCustomer = this.tags.find(tag => tag?.label === 'Admin/Customer')
                this.tagPermissions.push(adminCustomer?.label)
            } else if (event === 'demo') {
                let demo = this.tags.find(tag => tag?.label === 'Demo')
                this.tagPermissions.push(demo?.label)
            }
        },
    },
}
</script>

<style scoped>
.checkbox-row {
    display: flex;
    flex-direction: row;
}

.checkbox-padding {
    padding-right: 20px;
}
</style>
